var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5303 8.96965C10.2374 8.67676 9.76253 8.67676 9.46964 8.96965C9.17675 9.26255 9.17675 9.73742 9.46964 10.0303L11.4393 12L9.46966 13.9697C9.17677 14.2625 9.17677 14.7374 9.46966 15.0303C9.76255 15.3232 10.2374 15.3232 10.5303 15.0303L12.5 13.0607L14.4696 15.0303C14.7625 15.3232 15.2374 15.3232 15.5303 15.0303C15.8232 14.7374 15.8232 14.2625 15.5303 13.9696L13.5606 12L15.5303 10.0303C15.8232 9.73744 15.8232 9.26257 15.5303 8.96968C15.2374 8.67678 14.7625 8.67678 14.4696 8.96968L12.5 10.9393L10.5303 8.96965Z",
    fill: "#1E2D66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 1.25C6.56294 1.25 1.75 6.06294 1.75 12C1.75 17.9371 6.56294 22.75 12.5 22.75C18.4371 22.75 23.25 17.9371 23.25 12C23.25 6.06294 18.4371 1.25 12.5 1.25ZM3.25 12C3.25 6.89137 7.39137 2.75 12.5 2.75C17.6086 2.75 21.75 6.89137 21.75 12C21.75 17.1086 17.6086 21.25 12.5 21.25C7.39137 21.25 3.25 17.1086 3.25 12Z",
    fill: "#1E2D66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5303 8.96965C10.2374 8.67676 9.76253 8.67676 9.46964 8.96965C9.17675 9.26255 9.17675 9.73742 9.46964 10.0303L11.4393 12L9.46966 13.9697C9.17677 14.2625 9.17677 14.7374 9.46966 15.0303C9.76255 15.3232 10.2374 15.3232 10.5303 15.0303L12.5 13.0607L14.4696 15.0303C14.7625 15.3232 15.2374 15.3232 15.5303 15.0303C15.8232 14.7374 15.8232 14.2625 15.5303 13.9696L13.5606 12L15.5303 10.0303C15.8232 9.73744 15.8232 9.26257 15.5303 8.96968C15.2374 8.67678 14.7625 8.67678 14.4696 8.96968L12.5 10.9393L10.5303 8.96965Z",
    stroke: "#1E2D66",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 1.25C6.56294 1.25 1.75 6.06294 1.75 12C1.75 17.9371 6.56294 22.75 12.5 22.75C18.4371 22.75 23.25 17.9371 23.25 12C23.25 6.06294 18.4371 1.25 12.5 1.25ZM3.25 12C3.25 6.89137 7.39137 2.75 12.5 2.75C17.6086 2.75 21.75 6.89137 21.75 12C21.75 17.1086 17.6086 21.25 12.5 21.25C7.39137 21.25 3.25 17.1086 3.25 12Z",
    stroke: "#1E2D66",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/Close_circle.d265b418e458a6eab08465cf8678d237.svg";
export { ForwardRef as ReactComponent };